module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtMasterMsspSeven.0569a59.png";